import {useEffect,useMemo,useState} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import axios from 'axios'
import {useSelector, useDispatch} from 'react-redux';
import {Edit} from '@mui/icons-material';
import {Button, CircularProgress, Divider, Snackbar, TablePagination} from '@mui/material';
import ContentView from '../Components/ContentView';
import { styled, alpha,useTheme } from '@mui/material/styles';
import { add_report, add_reports } from '../Redux/reportsSlice';
import { useNavigate } from 'react-router-dom';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
maxHeight:400,
minHeight:300
})
);

const ItemBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
maxHeight:300,
minHeight:150
})
);

function Row(props) {

const { row,submitting,loading,handleAccept,handleScore,setVisible,setMessage } = props;
const test = useSelector(state => state?.templates.assessment);
const reports = useSelector(state => state?.reports.reports);
const user = useSelector(state => state?.auth.user);
const [open,setOpen] = useState(false)
const [change,setChange] = useState(false)
const [changing,setChanging] = useState(false)
const navigate = useNavigate()
const [score,setScore] = useState(row?.score)
const dispatch = useDispatch()
const [selected,setSelected] = useState(0)
const [sending,setSending] = useState(false)
const [loadding,setLoadding] = useState(false)

return (
    <>
    <TableRow hover sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
        >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        </TableCell>
        <TableCell align="left">{row?.last_name}</TableCell>
        <TableCell align="left">{row?.first_name}</TableCell>
        <TableCell align="left">{row?.email}</TableCell>
        <TableCell align="left">{row?.score}</TableCell>
        <TableCell align="left">
            <Typography sx={{fontSize:12,fontFamily:"dinofans",color:(row?.conclusion === "accept" ? "green" : row?.conclusion === "fail" ? "red" : "gold")}}>
                {row?.conclusion === "accept" ? "ACCEPTED" : row?.conclusion === "fail" ? "REJECTED"  : "PENDING" }
            </Typography>
        </TableCell>
        <TableCell align="left">
        <Typography sx={{fontSize:12,fontFamily:"dinofans",color:(row?.conclusion !== "pending" ? "green" :  "gold")}}>
                {row?.conclusion !== "pending"  ? "EVALUATED" :"NOT YET"  }
            </Typography>
        </TableCell>
        <TableCell align="left">
            <Button disabled={row?.isDisqualified}  onClick={(e)=>{
                e?.preventDefault()
                if(row?.isDisqualified){
                    setMessage("this candidate has been disqualified")
                    setVisible(true)
                }else{
                    dispatch(add_report(row))
                    navigate("/candidate")
                }
            }} sx={{background:"#fff",color:"black",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12}} variant="contained">
                View
            </Button>
        </TableCell>
    </TableRow>
    <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
        <Collapse in={open} timeout="auto" unmountOnExit>
            <ContainerBox sx={{margin:1,padding:1,color:"gray",textAlign:"left",marginBottom:0,width:"100%"}}>
                <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:13}}>
                    Assessment Detail
                </Typography>
                <Box width="100%" justifyContent="flex-start" alignItems="center">
                {
                    row?.sections?.map((item,index)=>{
                        
                        var total = 0

                        item?.data.forEach(it => {
                            total += it?.point
                        });

                    return(
                        <Box key={index}>
                        <Box width="100%" justifyContent="flex-start" alignItems="center">
                                <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:14,color:"#ff0"}}>
                                    {index+1} section
                                </Typography>
                                <Box width="70%" justifyContent="space-between" alignItems="center" flexDirection="row"  display="flex" flexWrap="wrap">
                                    <Box>
                                        <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                            title
                                        </Typography>
                                        <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                            {item?.title}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                            Total point
                                        </Typography>
                                        <Typography sx={{marginBottom:1,fontSize:13,color:"#ff0"}}>
                                            {total} / {item?.total_point} points
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                            Questions
                                        </Typography>
                                        <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                            {item?.total_questions}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                    Description
                                </Typography>
                                <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                    {item?.description}
                                </Typography>
                            </Box>
                        </Box>
                        )}
                    )
                }
                </Box>
            </ContainerBox>
            <Box display="flex" flexDirection="row">
                <ContentView title="Score" content= {`${row?.score} %`}/>
                <ContentView title="Status" content= {row?.conclusion === "accept" ? "ACCEPTED" : row?.conclusion === "fail" ? "REJECTED"  : "PENDING" }/>
            </Box>
            <Box>
                <Button disabled={((submitting || loading) || row?.conclusion === "accept") ? true : false}  onClick={()=>{
                    handleAccept(row?.email,"accept")
                }} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                    {
                        submitting ? <CircularProgress size={15} sx={{color:"black"}}/> : "ACCEPT"
                    }
                </Button>
                <Button disabled={((submitting || loading) || row?.conclusion === "fail")}  onClick={()=>{
                    handleAccept(row?.email,"fail")
                }} sx={{background:"gold",color:"black",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12}} variant="contained">
                    {
                        loading ? <CircularProgress size={15} sx={{color:"black"}}/> : "Reject"
                    }
                </Button>
            </Box>
        </Collapse>
        </TableCell>
    </TableRow>
    </>
);
}

Row.propTypes = {
row: PropTypes.shape({
    score: PropTypes.number.isRequired,
    last_name: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
}).isRequired,
};

export default function AssessmentTable({filterItem,setCandidate}) {

const theme = useTheme();
const test = useSelector(state => state?.templates.assessment);
const data = useSelector(state => state?.reports.reports);
const user = useSelector(state => state?.auth.user);
const [submitting,setSubmitting] = useState(false)
const [loading,setLoading] = useState(false)
const [expanded, setExpanded] = useState(false);
const [visible,setVisible] = useState(false)
const [accepted,setAccepted] = useState(0)
const [open, setOpen] = useState(false);
const [message,setMessage] = useState('')
const dispatch = useDispatch()
const [newData,setNewData] = useState(data)
const [order, setOrder] = useState('asc');
const [orderBy, setOrderBy] = useState('calories');
const [selected, setSelected] = useState([]);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);


const handleSnackbarClose = ()=>{
    setVisible(false)
}

async function handleAccept(email,typ) {
try{

    if (typ === "accept") {
        setSubmitting(true)
    } else {
        setLoading(true)
    }
    
    const send_data = {
        id:test.id,
        email:email,
        type:typ
    }

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}set-accept/` 

    const setPass = await axios.put(URL,send_data,{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
    }).catch(err=>{
        setSubmitting(false)
        setLoading(false)
        setMessage("connection error")
        setVisible(true)
    })
    
    if (setPass?.data.success && setPass.status == 200) {
        
        setCandidate(setPass?.data?.reports?.filter(item=>item?.conclusion === "accept"))
        const filterDta = setPass?.data.reports.filter((item)=>item.email !== email)
        dispatch(add_reports(filterDta))
        
        // console.log(setPass?.data)

        setSubmitting(false)
        setLoading(false)
    }else{
        setSubmitting(false)
        setLoading(false)
    }
    setMessage(setPass?.data?.message)
    setVisible(true)
}catch(err){
    console.log(err)
    setSubmitting(false)
    setLoading(false)
}
}

async function handleScore(email_data,score,setScore,setChange,setChanging){
try {

    if (score !== null) {

        const data = {
            id:test.id,
            email:email_data,
            score:score
        }
        setChanging(true)

        const handleSend = await axios.put(`${process.env.REACT_APP_SERVER_AUTH_URL}set-score/`,data,{
                headers:{
                        "Content-Type":"application/json",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{console.log(err)})

        if (handleSend?.status == 200 && handleSend?.data.success == true) {
            const filterDta = newData.filter((item)=>item.email !== email_data)
            const newFilterData = [...filterDta,handleSend?.data.report]

            setNewData(newFilterData)
            setChanging(false)
            setScore(null)
            setChange(false)
            setMessage(handleSend.data?.message)
            setOpen(true)

        } else {
            setMessage(handleSend?.data?.message)
            setOpen(true)
            setChanging(false)
        }
    } else {
        setMessage("write down the score")
        setOpen(true)			
    }

} catch (error) {
    console.log(error)
}
}

const handleChangePage = (event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target.value, 10));
    setPage(0);
};

const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - newData.length) : 0;

useEffect(()=>{
setNewData(data)
},[data])

return (
    <>
        <Snackbar 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} 
            message={message} 
            onClose={handleSnackbarClose} 
            open={visible} 
            autoHideDuration={2000}
        />
        {newData?.filter(item=>item?.conclusion === filterItem )?.length == 0 && (
            <Box sx={{width:"100%",alignItems:"center",justifyContent:"center",flexDirection:"row",marginTop:2,display:"flex"}}>
                <Edit fontSize='small' name="edit" sx={{color:"gold"}}/>
                <Typography sx={{color:"white",padding:1,fontSize:12}}>
                    None of all participant have those params
                </Typography>
            </Box>
            )
        }
        {newData?.filter(item=>item?.conclusion === filterItem )?.length > 0 && (
            <>
            <TableContainer component={Paper} sx={{width:"95%",margin:1}}>
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <TableCell/>
                        <TableCell >Last&nbsp;Name</TableCell>
                        <TableCell align="left">First&nbsp;Name</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Score&nbsp;(%)</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Evaluation</TableCell>
                        <TableCell align="left">View</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {newData?.filter(item=>item?.conclusion === filterItem )?.map((row,index) => (
                            <Row key={index} row={row} submitting={submitting} loading={loading} handleAccept={handleAccept} handleScore={handleScore} setMessage={setMessage} setVisible={setVisible}/>
                        ))}
                        {emptyRows > 0 && (
                            <TableRow
                            style={{
                                height: 53 * emptyRows,
                            }}
                            >
                            <TableCell colSpan={6} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer> 
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                labelRowsPerPage={<Typography sx={{fontSize:11,color:"#ff0"}}>
                                    assessment per page
                                </Typography>}
                count={newData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>
            )}
    </>

);
}
